import React from "react";
import ShowtimesGrid from "./ShowtimesGrid";
import ShowtimeButton from "./ShowtimeButton";
import { CinemaType, MovieType } from "../../../types/entities";
import styled from "styled-components";

const Title = styled.h3`
    margin: 1.25em 0;
    font-size: 1.1rem;
    font-weight: 700;
`;

interface Props {
    cinema: CinemaType;
    movie: MovieType;
    showtimes: any[];
    language: string
};

const ShowtimesLanguageBlock = (props: Props) => {
    const { cinema, language, movie, showtimes } = props;

    if (!showtimes || !showtimes.length) {
        return null;
    }

    return (
        <div>
            <Title>{language}</Title>
            <ShowtimesGrid>
                {showtimes.map((session, j) => (
                    <ShowtimeButton key={session.session.id}
                        cinema={cinema}
                        session={session.session}
                        version={session.version}
                        movieName={movie.name}
                    />
                ))}
            </ShowtimesGrid>
        </div>
    );
};

export default ShowtimesLanguageBlock;